import { ITgInsets, ITgInsetsPresetId } from "./types"

export const TG_INSET_PRESETS: Record<
  Exclude<ITgInsetsPresetId, "custom">,
  ITgInsets
> = {
  off: {
    "safe-area-inset-top": 0,
    "safe-area-inset-bottom": 0,
    "safe-area-inset-left": 0,
    "safe-area-inset-right": 0,
    "content-safe-area-inset-top": 0,
    "content-safe-area-inset-bottom": 0,
    "content-safe-area-inset-left": 0,
    "content-safe-area-inset-right": 0
  },
  "iphone-15-pro-landscape": {
    "safe-area-inset-top": 0,
    "safe-area-inset-bottom": 20,
    "safe-area-inset-left": 59,
    "safe-area-inset-right": 59,
    "content-safe-area-inset-top": 46,
    "content-safe-area-inset-bottom": 0,
    "content-safe-area-inset-left": 0,
    "content-safe-area-inset-right": 0
  }
}
